import { jsx as o } from "react/jsx-runtime";
const m = ({
  name: n,
  override: t,
  haveChildren: p,
  renderChildren: c,
  attribs: r
}) => {
  const e = t[n];
  return p ? /* @__PURE__ */ o(e, { ...r, children: c() }) : /* @__PURE__ */ o(e, { ...r });
};
export {
  m as overrideComponentInterceptor
};
